import styled, { css } from 'styled-components'
import { Menu } from 'antd'
import { themeColor, themeFontFamily } from 'LibNeo'

interface ComponentProps {
	$danger: boolean
	$dividerTop: boolean
	$dividerBottom: boolean
}

export const DropdownList = styled(Menu)`
	background-color: ${themeColor('gray', 9)};
	border-radius: 6px;
	padding: 6px 0;
`

export const DropdownListItem = styled(Menu.Item)<Partial<ComponentProps>>`
	padding: 6px 16px;
	font-family: ${themeFontFamily('SBSansInterface')};
	font-size: 14px;
	line-height: 20px;
	color: ${({ $danger }) => ($danger ? themeColor('pink', 5) : themeColor('white'))};

	&:hover {
		background-color: ${({ $danger }) =>
			$danger ? themeColor('pink', 5) : themeColor('emerald', 5)};
		${({ $danger }) =>
			$danger &&
			css`
				color: ${themeColor('white')};
			`}
	}

	${({ $dividerTop }) =>
		$dividerTop &&
		css`
			border-top: 1px solid ${themeColor('gray', 8)};
		`}

	${({ $dividerBottom }) =>
		$dividerBottom &&
		css`
			border-bottom: 1px solid ${themeColor('gray', 8)};
		`}
`
